import { getEnvironment } from '@/utils/environment';

// Environment-specific form IDs
const FORM_IDS_BY_ENVIRONMENT = {
  development: {
    happy: 5,
    meh: 7,
    sad: 6,
  },
  preview: {
    happy: 5,
    meh: 7,
    sad: 6,
  },
  test: {
    happy: 5,
    meh: 7,
    sad: 6,
  },
  production: {
    happy: 1,
    meh: 3,
    sad: 2,
  },
} as const;

export const FORM_IDS = FORM_IDS_BY_ENVIRONMENT[getEnvironment()];

export const CREATE_CUSTOMER_FEEDBACK_SOURCE = 'CONSUMER_SITE';
